<template>
  <div style="padding: 0 10px">
    <el-tabs v-model="processNode" type="card" @tab-click="handleClick">
      <el-tab-pane :label="`待仓库处理(${countData.warehouseProcessTotal})`" name="3"></el-tab-pane>
      <el-tab-pane :label="`采购处理中(${countData.purchaseProcessTotal})`" name="1"></el-tab-pane>
      <el-tab-pane :label="`已完成(${countData.alreadyProcessTotal})`" name="999"></el-tab-pane>
    </el-tabs>
    <Form layout="expNo,date" @search="search" ref="Form"></Form>
    <WmsTable :isPagination="query" :columns="columns" :dataSource="datasource" @pageChange="pageChangeCall"
      :hasHeader="false">
      <div slot="errorImg" slot-scope="{text}" style="padding:0">
        <ImgPreviews :images="text" v-if="text" :width="50" :height="50"></ImgPreviews>
      </div>
      <div slot="tag"  slot-scope="{text,record}">
        <div v-if="record.exceptionCodes[0] == 103">
          <div v-for="i in record.processResults">{{ `${i.amount}件${i.flowTagName}(${i.pkgCode})` }}</div>
        </div>
        <div v-else-if="record.oemMoreInboundException">
          <div v-for="item in record.processResults">{{ `${item.amount}件${item.flowTagName}(${item.pkgCode})` }}</div>
        </div>
        <div v-else-if="record.tag">
          {{ taglist[taglist.findIndex(i=>i.value == record.tag)].label }}
        </div>
        <div v-else></div>
      </div>
      <div slot="action" slot-scope="{record}">
        <a @click="log(record)">日志</a>
        <a @click="mark(record)" style="margin-left:10px" v-if="processNode == 3">标记已处理</a>
      </div>
    </WmsTable>
    <el-dialog :visible="visible" title="日志" width="1000px" @close="visible = false">
      <WmsTable :isPagination="false" :columns="logColumns" :dataSource="logList" :hasHeader="false">
      </WmsTable>
    </el-dialog>
  </div>
</template>

<script>
import Form from "@/views/abnormal/components/form";
import WmsTable from "@/components/WmsTable";
import ImgPreviews from "@/components/ImgPreviews"
import { columns, taglist, logColumns } from "./columns";
import { abnormalPackage, recordInfo, wareDealFlow, abnormalPackageCount } from "@/apis/abnormal";

export default {
  name: 'abnormal_list',
  components: { Form, WmsTable, ImgPreviews },
  props: {},
  data() {
    return {
      processNode: "3",
      columns,
      taglist,
      datasource: [],
      dialogVisible: false,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      visible: false,
      logList: [],
      logColumns,
      countData: {}
    };
  },
  deactivated() {
  },
  methods: {
    handleClick() {
      // this.$refs.Form.rest()
      this.getDataSource();
      this.getCount()
    },
    search(formInline) {
      this.formInline = formInline;
      this.query.current = 1
      this.getDataSource();
      this.getCount()
    },
    getDataSource() {
      let params = { ...this.formInline };
      params.pageSize = this.query.pageSize;
      params.pageNum = this.query.current;
      params.processNode = Number(this.processNode)
      if(params.processNode != '999'){
        params.wareStatus = 0
      }else{
        delete params.processNode
        params.wareStatus = 1
      }
      params.createTimeBegine && (params.createTimeStart = params.createTimeBegine)
      // params.pkgTypes = [3, 4];
      abnormalPackage(params).then(({ code, data }) => {
        if (code === 0) {
          this.datasource = data.records;
          this.query.total = data.total;
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
      this.getCount()
    },
    log(r) {
      console.log(r)
      const params = {
        flowCode: r.flowCode
      }
      recordInfo(params).then(({ code, data }) => {
        if (code === 0) {
          console.log(data)
          this.logList = data
          this.visible = true
        }
      })
    },
    mark(r) { 
      let params = {
        flowCode: r.flowCode,
        wareStatus: 1,
      };
      wareDealFlow(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.getDataSource()
      this.getCount()
        }
      });
    },
    getCount () {
      abnormalPackageCount().then(res => {
        this.countData = res.data
      })
    }
  },
};
</script>

<style scoped lang="less"></style>
